import { createSelector } from 'reselect'

const selectUserEvent = state => state.userevents

const selectFootprintSaving = createSelector(
  selectUserEvent,
  userevents => userevents.isFootprintSaving
)

const selectFootprintId = createSelector(
  selectUserEvent,
  userevents => userevents.footprintId
)

export { selectFootprintSaving, selectFootprintId }



// WEBPACK FOOTER //
// ./src/containers/UserEvents/selectors.js